import { Container, Row, Col, Button, Image, Card } from 'react-bootstrap';
import SectionHero from './components/SectionHero';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

export default function Home() {

  AOS.init();
  return (
    <>
    <SectionHero />
      <Container className='py-5'>
        <Row>
          <Col md={6} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 border-2  border-bpp-pink' data-aos="fade-up" data-aos-delay="50">
                <Card.Body className='p-4'>
                <h6 className='m-0'><span className='text-bpp-pink'>Abstract submission</span><br></br>April 30, 2026</h6>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 border-2 border-bpp-pink' data-aos="fade-up" data-aos-delay="250">
                <Card.Body className='p-4'>
                <h6 className='m-0'><span className='text-bpp-pink'>Early Bird Registration</span><br></br>July 15, 2026</h6>
                </Card.Body>
              </Card>
            </Col>
            
        </Row>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pb-5'>
            <h2 className='h1 my-5 purple-h'>The Conference</h2>
            <p>The <highlight>Biopartitioning and Purification Conference (BPP)</highlight> has evolved since its launch, which was originally centred on aqueous two-phase partitioning. Beginning with BPP2013 in Vancouver, the conference expanded its scope to encompass a broader range of bioseparation techniques.</p>
            <p>
              While the conference remains dedicated to advancing bioseparation and purification technologies, it has <highlight>broadened</highlight> its scope to include areas of <highlight>increasing</highlight> interest and relevance. Today, BPP is a forum for participants from academia and industry focused on the separation of high-value bioproducts, <highlight>enhanced</highlight> by discussions on innovative biomass processing and waste valorisation strategies, the development of novel bioproducts, technoeconomic analysis, life cycle assessment, and regulatory frameworks. In addition, BPP 2026 will feature process integration and optimisation using artificial intelligence and multiscale modelling, fostering a comprehensive exchange of knowledge and ideas to drive innovation in sustainable bioprocessing.
            </p>
              <p>Beyond the technical sessions, BPP 2026 will include <highlight>plenary and keynote lectures by leading experts</highlight>, poster presentations, an interactive round table discussion, and ample networking opportunities. This conference serves as an excellent platform for researchers and industry professionals to present their findings, identify opportunities for collaboration, and discuss how to apply new bioprocessing developments in practical contexts. </p>
          </Col>
        </Row>

        

        

        <Row className='align-items-center my-5'>
          <Col lg='6' className='pe-lg-5'>
            <div className="position-relative ps-4 pt-4">
              <Image src='images/bled-1.webp' className="img-fluid " data-aos="fade-right" data-aos-delay="50" />
              <div className="svg-overlay position-absolute"><Image src="images/bpp-02-h.svg" data-aos="fade-down" data-aos-delay="250"/></div>
            </div>
          </Col>
          <Col lg='6' className='py-5'>
            <h2 className='h1 my-5 purple-h'>The Venue</h2>
            <p>We are thrilled to host this year’s conference in <highlight>one of the most picturesque locations in Europe – Bled, Slovenia.</highlight> Nestled at the foot of the Julian Alps, Bled offers breathtaking natural beauty, a rich cultural heritage, and world-class hospitality.</p>
            <p> With its iconic lake, charming island church, and medieval castle perched high above the water, <highlight>Bled is more than just a destination – it’s an experience.</highlight> Whether you're enjoying the views, engaging in meaningful conversations, or discovering new ideas, Bled provides the perfect backdrop for inspiration and connection.</p>
            <Link  as={Link} to="/venue"><Button variant="bpp-pink" size="lg" className='text-white mt-3'>Venue info</Button></Link>
          </Col>
        </Row>
      </Container>
    <Footer />

    </>
  );
}
 